import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import CloseIcon from '@mui/icons-material/Close';
import FlagIcon from '@mui/icons-material/Flag';
import { Backdrop, Button, Card, CardHeader, IconButton, styled, Table, TableBody, TableCell, TableFooter, TableHead, TableRow, } from '@mui/material';
import { useState } from 'react';
import { featureFlags, useResetFlags, } from '@zurich/common/featureFlags';
import { AutocompleteOptions } from '../../Autocomplete';
import { CardContent } from '../../Card';
import { FeatureFlagEntry } from './FeatureFlagEntry';
function toUiOption(value) {
    return { label: value, value };
}
function fromUiOption(option) {
    return option.value;
}
export function FeatureFlagsOverlay({ onClose }) {
    const [filter, setFilter] = useState([]);
    const resetFlags = useResetFlags();
    const uniqueTags = [
        ...new Set(Object.values(featureFlags).flatMap((flag) => flag.tags)),
    ];
    const tagFilters = uniqueTags.map(toUiOption);
    return (_jsx(Backdrop, { open: true, sx: {
            zIndex: 11,
        }, children: _jsxs(Card, { children: [_jsx(CardHeaderStyled, { title: _jsxs(_Fragment, { children: [_jsx(FlagIcon, {}), _jsx(CardHeaderTitleStyled, { children: "Feature Flags" })] }), action: _jsx(IconButton, { "aria-label": "close", onClick: onClose, size: "large", children: _jsx(CloseIcon, {}) }) }), _jsx(CardContentStyled, { children: _jsxs(Table, { children: [_jsx(TableHead, { children: _jsxs(TableRow, { children: [_jsx(TableCell, { colSpan: 2, sx: { paddingTop: 0, paddingBottom: 3 }, children: _jsx(AutocompleteOptions, { multiple: true, size: "small", label: "Filtern nach Tags", options: tagFilters, onChange: (_, values) => setFilter(values.map(fromUiOption)), value: filter.map(toUiOption) }) }), _jsx(EmptyTableCellStyled, { colSpan: 2 })] }) }), _jsx(TableBodyStyled, { children: Object.entries(featureFlags)
                                    .filter(([_, flag]) => flag.sources.includes('client'))
                                    .filter(([_, flag]) => filter.every((tag) => flag.tags.includes(tag)))
                                    // Show TEST flag only when run in TEST mode
                                    .filter(([_, flag]) => {
                                    if (flag.title === 'TEST') {
                                        if (typeof window !== 'undefined' &&
                                            'PLAYWRIGHT_ENV' in window &&
                                            window.PLAYWRIGHT_ENV === true) {
                                            return true;
                                        }
                                        return false;
                                    }
                                    return true;
                                })
                                    .map(([key, flag]) => (_jsx(FeatureFlagEntry, { flagKey: key, title: flag.title, description: flag.description, tags: flag.tags, 
                                    // @ts-expect-error
                                    possibleValues: flag.possibleValues }, key))) }), _jsx(TableFooter, { children: _jsx(TableRow, { children: _jsx(TableCell, { colSpan: 2, children: _jsx(Button, { variant: "text", onClick: resetFlags, children: "Alle Feature Flags auf Standardwerte zur\u00FCcksetzen" }) }) }) })] }) })] }) }));
}
const TableBodyStyled = styled(TableBody)({
    overflowY: 'auto',
    maxHeight: '50vh',
    display: 'block',
});
const CardContentStyled = styled(CardContent)({
    maxWidth: '1024px',
});
const CardHeaderStyled = styled(CardHeader)({
    paddingBottom: 0,
});
const CardHeaderTitleStyled = styled('span')(({ theme }) => ({
    paddingLeft: theme.spacing(1),
    position: 'relative',
    top: '-3px',
}));
const EmptyTableCellStyled = styled(TableCell)({
    padding: 0,
});
